<template>
  <div class="ordersComp">
    <tbl-comp
      :model="this.$store.getters[`${this.moduleName}/getModel`]"
      :paging="true"
      :rowClick="rowClick"
      :moduleName="moduleName"
      :params="params"
      :searchInput="false"
    />
  </div>
</template>

<script>
export default {
  name: 'ordersComp',
  props: {
    params: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data: function () {
    return {
      moduleName: 'orders',
      required: ['id', 'createdAt', 'command', 'info', 'price', 'status'],
      users: {
        moduleName: 'users'
      }
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/setModelRequired`, { required: this.required })
  },
  components: {
  },
  computed: {
  },
  methods: {
    rowClick (row) {
      this.$store.commit(`${this.moduleName}/setUserId`, row.userId)
      this.$store.dispatch(`${this.moduleName}/toUpdate`, { id: row.id })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
